import React, { useEffect } from "react";
import { FiBriefcase } from 'react-icons/fi';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss';
import { trackSectionView } from '../utils/mixpanel';
import { SectionHeader } from './ui';

const experiences = [
  {
    date: '2024 - Present',
    title: 'Technical Team Lead — Mobile Apps',
    company: 'Echosoft Solutions',
    location: 'Germany (Remote)',
    description: 'Leading cross-functional mobile teams delivering Android & iOS products for European clients. Overseeing architecture decisions, backend integration, client communication, and end-to-end product delivery.',
    tags: ['Android', 'iOS', 'Backend', 'Team Lead', 'Client Management'],
  },
  {
    date: '2023 - 2024',
    title: 'Mobile Application Developer',
    company: 'Hello Super App',
    location: 'United Kingdom (Remote)',
    description: 'Built and scaled a consumer Super App from the ground up, handling full-stack mobile development, backend integration, and product strategy in a fast-paced UK startup environment.',
    tags: ['Super App', 'Android', 'iOS', 'Backend', 'Product Development'],
  },
  {
    date: '2022 - 2023',
    title: 'Senior Android Developer',
    company: 'Kstyles',
    location: 'South Korea (Remote)',
    description: 'Delivered production-grade Android features with a focus on clean architecture, Jetpack Compose UI, unit testing, and robust API integrations for a Korean tech product.',
    tags: ['Kotlin', 'Jetpack Compose', 'MVVM', 'Unit Testing', 'Retrofit'],
  },
  {
    date: '2021 - 2022',
    title: 'Senior Android Developer',
    company: 'Geeklone Technology',
    location: 'Lahore, Pakistan',
    description: 'Developed AI-driven mobile applications, led a team of engineers, managed client relationships, and drove product development from concept to deployment.',
    tags: ['AI', 'Android', 'Team Lead', 'Product Development'],
  },
  {
    date: '2020 - 2021',
    title: 'Android Developer',
    company: 'Ozi Technology',
    location: 'Lahore, Pakistan',
    description: 'Engineered Android applications with a focus on performance, clean code, REST API integration, dependency injection, and comprehensive unit testing.',
    tags: ['Android', 'Kotlin', 'REST APIs', 'Dagger', 'Unit Testing'],
  },
  {
    date: '2019 - 2020',
    title: 'Android Application Developer',
    company: 'Echosoft Solutions',
    location: 'Pakistan',
    description: 'Started professional career building native Android apps, mentoring interns, and shaping early expertise in mobile UX and application architecture.',
    tags: ['Android', 'Java', 'UX', 'Training'],
  },
  {
    date: '2017 - 2019',
    title: 'Android Developer',
    company: 'ByteSole',
    location: 'Pakistan',
    description: 'Developed native Android applications, trained junior developers, and collaborated closely with backend teams to deliver integrated mobile solutions.',
    tags: ['Android', 'Java', 'Collaboration', 'Mentoring'],
  },
];

function Timeline() {
  useEffect(() => {
    trackSectionView('history');
  }, []);

  return (
    <section className="timeline-section" id="history">
      <div className="timeline-section__container">
        <SectionHeader title="Career History" align="left" />
        <VerticalTimeline lineColor="var(--border-color)">
          {experiences.map((exp, index) => (
            <VerticalTimelineElement
              key={index}
              className="vertical-timeline-element--work"
              date={exp.date}
              iconStyle={{ background: '#3b82f6', color: 'white', boxShadow: '0 0 0 4px #f8f9fa, 0 0 0 6px #3b82f6' }}
              icon={<FiBriefcase />}
              contentStyle={{ background: 'transparent', boxShadow: 'none', padding: 0, border: 'none' }}
              contentArrowStyle={{ display: 'none' }}
            >
              <div className="tl-card">
                <div className="tl-card__header">
                  <div>
                    <h3 className="tl-card__title">{exp.title}</h3>
                    <span className="tl-card__company">{exp.company}</span>
                    <span className="tl-card__sep">·</span>
                    <span className="tl-card__location">{exp.location}</span>
                  </div>
                </div>
                <p className="tl-card__desc">{exp.description}</p>
                <div className="tl-card__tags">
                  {exp.tags.map((tag) => (
                    <span key={tag} className="tl-card__tag">{tag}</span>
                  ))}
                </div>
              </div>
            </VerticalTimelineElement>
          ))}
        </VerticalTimeline>
      </div>
    </section>
  );
}

export default Timeline;
